import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  loadingShow(duration: number = 0): void {
    this.loadingSubject.next(true);
    setTimeout(() => this.loadingHide(), duration);
  }

  loadingHide(): void {
    this.loadingSubject.next(false);
  }
}
